import React, { useContext, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { FiSearch, FiHome } from 'react-icons/fi';

const Header = ({ pageTitle, onSearch }) => {
  const { user } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const previousPathRef = useRef(location.pathname);

  // Track the path before navigating to search, so the home button can go back
  const getTitleFromPath = () => {
    const path = location.pathname;
    if (path === '/' || path === '/dashboard') return 'Dashboard';
    if (path.startsWith('/shipments')) return 'Shipments';
    if (path.startsWith('/invoices')) return 'Invoices';
    if (path.startsWith('/payments')) return 'Payments';
    if (path === '/reports') return 'Reports';
    return 'MyLogistic';
  };

  const handleChange = (e) => {
    const val = e.target.value;
    setQuery(val);
    if (onSearch) onSearch(val);
  };

  const handleSearch = () => {
    if (query.trim().length >= 2) {
      // Remember current path before navigating to search
      if (!location.pathname.startsWith('/search')) {
        previousPathRef.current = location.pathname;
      }
      navigate(`/search?q=${encodeURIComponent(query.trim())}`);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  // Determine "home" path based on where the user came from
  const getHomePath = () => {
    const prev = previousPathRef.current || '/';
    // Map detail pages back to their list
    if (prev.match(/^\/truck\/\d+/) || prev === '/truck/new') return '/truck';
    if (prev.match(/^\/ocean-import\/\d+/) || prev === '/ocean-import/new') return '/ocean-import';
    if (prev.match(/^\/ocean-export\/\d+/) || prev === '/ocean-export/new') return '/ocean-export';
    if (prev.match(/^\/air-import\/\d+/) || prev === '/air-import/new') return '/air-import';
    if (prev.match(/^\/misc\/\d+/) || prev === '/misc/new') return '/misc';
    if (prev.startsWith('/trade-partner')) return '/trade-partner';
    if (prev.startsWith('/charge')) return '/invoice-cost';
    if (prev.startsWith('/payment')) return prev;
    // For list pages, go back to them directly
    if (prev.startsWith('/truck')) return '/truck';
    if (prev.startsWith('/ocean-import')) return '/ocean-import';
    if (prev.startsWith('/ocean-export')) return '/ocean-export';
    if (prev.startsWith('/air-import')) return '/air-import';
    if (prev.startsWith('/misc')) return '/misc';
    return '/dashboard';
  };

  const isSearchPage = location.pathname.startsWith('/search');

  return (
    <div className="header">
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        {isSearchPage && (
          <button
            onClick={() => navigate(getHomePath())}
            title="Back to previous page"
            style={{
              background: 'none', border: '1px solid #d1d5db', borderRadius: '6px',
              padding: '6px 8px', cursor: 'pointer', display: 'flex', alignItems: 'center',
              color: '#475569', fontSize: '16px',
            }}
            onMouseEnter={e => { e.currentTarget.style.background = '#f1f5f9'; e.currentTarget.style.borderColor = '#3b82f6'; e.currentTarget.style.color = '#3b82f6'; }}
            onMouseLeave={e => { e.currentTarget.style.background = 'none'; e.currentTarget.style.borderColor = '#d1d5db'; e.currentTarget.style.color = '#475569'; }}
          >
            <FiHome size={16} />
          </button>
        )}
        <h1 className="page-title">{pageTitle || getTitleFromPath()}</h1>
      </div>
      <div className="header-right">
        <div className="search-bar" style={{ position: 'relative' }}>
          <FiSearch style={{ cursor: 'pointer' }} onClick={handleSearch} />
          <input
            type="text"
            placeholder="Search..."
            value={query}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
          />
        </div>
        <div style={{ fontSize: '14px', color: '#7f8c8d' }}>
          {user?.name || 'User'}
        </div>
      </div>
    </div>
  );
};

export default Header;
